import React, { useState, useEffect } from "react";

// firebase hooks
import { firestore, useFirebase, firefunctions } from "./FirebaseProvider";
import {
  useCollectionData,
  useCollectionDataOnce,
  useDocumentData,
  useDocumentDataOnce,
} from "react-firebase-hooks/firestore";
import AppLoading from "../appLoading";
import { arrayToTree } from "performant-array-to-tree";
// utilities
// import { arrayToTree } from 'performant-array-to-tree';

// context untuk menyimpan profil user terautentikasi, level, webstore, dan roles
const DataContext = React.createContext();

export function useData() {
  return React.useContext(DataContext);
}

//firestore collections
export const ordersCollection = firestore.collection("orders");
export const webstoreCollection = firestore.collection("webstores");
export const productsCollection = firestore.collection("products");
export const subdomainsCollection = firestore.collection("subdomains");
export const brandCollection = firestore.collection("brand");
export const kategoriCollection = firestore.collection("categories");
export const belanjaKreditCollection = firestore.collection(
  "belanja_dengan_kredit"
);
export const pencairanCollection = firestore.collection("pencairan");
export const kreditCollection = firestore.collection("kredit");
export const bankSellerCollection = firestore.collection("bank_seller");
export const topupCollection = firestore.collection("topup");
export const categoriesCollection = firestore.collection("categories");
export const sliderCollection = firestore.collection("slider");
export const usersCollection = firestore.collection("users");
export const bannerCollection = firestore.collection("banner");
export const appNotificationCollection = firestore.collection("notifications");
export const phoneCollection = firestore.collection("phones");
export const feedbackCollection = firestore.collection("feedback");
export const pointRewardCollection = firestore.collection("point");
export const promoCollection = firestore.collection("promo");
export const productsRewardCollection = firestore.collection("products_reward");
export const penukaranRewardCollection =
  firestore.collection("penukaran_reward");
export const promoOngkirCollection = firestore.collection("promo_ongkir");
export const campaignsCollection = firestore.collection("campaigns");
export const voucherCollection = firestore.collection("vouchers");
export const verifikasiCollection = firestore.collection("identifier_number");
export const inpoinCollection = firestore.collection("inpoin");
export const popupsCollection = firestore.collection("popups");
export const designContestCollection = firestore.collection("design_contest");
export const utilityCollection = firestore.collection("utility");
export const collectionProductRef = firestore.collection("collections");
export const productsCampaignsCollections = firestore.collection("products_campaigns");

export default function DataProvider(props) {
  const { user } = useFirebase();
  // const [now] = useState(new Timestamp(Date.now() / 1000))

  // get and listen user data dari path users/{user.uid}/inpoint
  const inpoinRef = firestore.doc(`users/${user.uid}/inpoin/activity`);
  const [inpoinActivity, loadingInpoinActivity] = useDocumentData(inpoinRef, {
    idField: "id",
  });

  const userInpoinRef = firestore.collection(`users/${user.uid}/inpoin`);
  const [userInpoin, loadingUserInpoin] = useCollectionData(userInpoinRef, {
    idField: "id",
  });
  // get how to inpoin
  const inpointHowRef = inpoinCollection.doc(`howto`);
  const [inpointHow, loadingInpoinHow, errorInpointHow] = useDocumentData(
    inpointHowRef,
    { idField: "id" }
  );
  //about
  const inpointAboutRef = inpoinCollection.doc(`about`);
  const [inpointAbout, loadingInpoinAbout, errorInpointAbout] = useDocumentData(
    inpointAboutRef,
    { idField: "id" }
  );

  // get and listen profil data dari path users/{user.uid}
  const profilRef = firestore.doc(`users/${user.uid}`);
  const [profil, loadingProfil] = useDocumentData(profilRef, { idField: "id" });

  // get and listen level data dari path levels/${user.uid}
  const levelRef = firestore.doc(`levels/${user.uid}`);
  const [level, loadingLevel] = useDocumentData(levelRef, { idField: "id" });

  // only get once  kategori collection dari path kategori
  const categoriesRef = firestore.collection("categories");
  const [categories, loadingCategories] = useCollectionDataOnce(categoriesRef, {
    idField: "id",
  });

  // get and liste cart data from path cart/${user.uid}
  const cartRef = firestore.doc(`carts/${user.uid}`);
  const [cart, loadingCart] = useDocumentData(cartRef, { idField: "id" });

  // get alamat collection from path users/${user.ud}/alamat
  const alamatRef = profilRef.collection("alamat");
  const [alamat, loadingAlamat] = useCollectionData(alamatRef, {
    idField: "id",
  });

  // get webstore doc for user
  const webstoreRef = webstoreCollection.doc(user.uid);
  const [webstore, loadingWebstore] = useDocumentData(webstoreRef, {
    idField: "id",
  });

  // get subdomain
  const subdomainsRef = subdomainsCollection.where("user_id", "==", user.uid);
  const [subdomain, loadingSubdomain] = useCollectionData(subdomainsRef, {
    idField: "id",
  });

  // get orders
  const ordersRef = ordersCollection.where(
    "order_info.owner_id",
    "==",
    user.uid
  );
  const [orders, loadingOrders] = useCollectionData(ordersRef, {
    idField: "id",
  });

  //get belanja dengan kredit
  const belanjaKreditRef = belanjaKreditCollection.where(
    "user_id",
    "==",
    user.uid
  );
  const [belanjaKredit, loadingBelanjaKredit] = useCollectionData(
    belanjaKreditRef,
    { idField: "id" }
  );

  //get pencairan
  const pencairanRef = pencairanCollection.where("user_id", "==", user.uid);
  const [pencairan, loadingPencairan] = useCollectionData(pencairanRef, {
    idField: "id",
  });

  // get kredit
  const kreditRef = kreditCollection.doc(user.uid);
  const [kredit, loadingKredit] = useDocumentData(kreditRef, { idField: "id" });

  // get bank seller
  const bankSellerRef = bankSellerCollection.where("user_id", "==", user.uid);
  const [bankSeller, loadingBankSeller] = useCollectionData(bankSellerRef, {
    idField: "id",
  });

  // get topup
  const topupRef = topupCollection.where("user_id", "==", user.uid);
  const [topup, loadingTopup] = useCollectionData(topupRef, { idField: "id" });

  // get only once slider
  const sliderRef = sliderCollection.orderBy("sorting_number").limit(10);
  const [slider, loadingSlider] = useCollectionDataOnce(sliderRef, {
    idField: "id",
  });

  // get only once alamat pusat
  const [alamat_pusat, loadingAlamatPusat] = useDocumentDataOnce(
    firestore.doc("settings/alamat_pusat"),
    { idField: "id" }
  );
  const [global_settings, loadingOrderCreation] = useDocumentData(
    firestore.doc("settings/global"),
    { idField: "id" }
  );

  // get user phone
  const phoneRef = phoneCollection.where("user_id", "==", user.uid);
  const [phone, loadingPhone] = useCollectionDataOnce(phoneRef, {
    idField: "id",
  });

  // get point user
  const pointRef = pointRewardCollection.where("user_id", "==", user.uid);
  const [point, loadingPoint] = useCollectionData(pointRef, { idField: "id" });

  //active promo
  const promoRef = promoCollection.where("status", "==", "active");
  const [promo, loadingPromo] = useCollectionData(promoRef, { idField: "id" });
  const promoOngkirRef = promoOngkirCollection.where("status", "==", "active");
  const [promoOngkir, loadingPromoOngkir] = useCollectionData(promoOngkirRef, {
    idField: "id",
  });
  // get campaigns
  const campaignsRef = campaignsCollection.where("show", "==", true);
  const [campaigns, loadingCampaigns] = useCollectionData(campaignsRef, {
    idField: "id",
  });
  // get campaigns infaq
  const campaignsInfaqRef = campaignsCollection
    .where("status", "==", "active")
    .where("tipe", "==", "infaq");
  const [campaignsInfaq, loadingCampaignsInfaq] = useCollectionData(
    campaignsInfaqRef,
    {
      idField: "id",
    }
  );
  // get voucher
  const voucherRef = voucherCollection
    .where("status", "==", "active")
    .where("location", "in", ["all", "sellerapp"]);
  const [voucherData, loadingVoucherData] = useCollectionData(voucherRef, {
    idField: "id",
  });

  // get penukaran reward user
  const penukaranRef = penukaranRewardCollection.where(
    "user_id",
    "==",
    user.uid
  );
  const [penukaran, loadingPenukaran] = useCollectionData(penukaranRef, {
    idField: "id",
  });
  //get kpt
  const verifikasiRef = verifikasiCollection.doc(user.uid);
  const [verifikasiData, loadingVerifikasiData] = useDocumentData(
    verifikasiRef,
    { idField: "id" }
  );

  // const [global_komisi, loadingGlobal_Komisi] = useDocumentData(
  //   firestore.doc("settings/komisi"),
  //   { idField: "id" }
  // );

  const [global_resi_mp, loadingGlobal_resi_mp] = useDocumentData(
    firestore.doc("settings/resi_mp"),
    { idField: "id" }
  );
  const [configuration, loadingConfiguration] = useDocumentData(
    firestore.doc("settings/configuration"),
    { idField: "id" }
  );
  const [menu_alamat, loadingMenu_alamat] = useDocumentData(
    firestore.doc("settings/alamat"),
    { idField: "id" }
  );
  const [list_pekerjaan, loadingList_pekerjaan] = useDocumentData(
    firestore.doc("settings/pekerjaan"),
    { idField: "id" }
  );
  const [jenisBrand, loadingJenisBrand] = useDocumentData(
    firestore.doc("utility/brand"),
    { idField: "id" }
  );
  const [performance, loadingPerformance] = useDocumentData(
    firestore.doc("utility/performance"),
    { idField: "id" }
  );
  // get popups reward user
  const popupRef = popupsCollection.where("status", "==", "active");
  const [popups, loadingPopups] = useCollectionDataOnce(popupRef, {
    idField: "id",
  });

  const [visiblePopups, setVisiblePopups] = useState({});

  const [sourceCategories, loadingSourceCategories] = useDocumentDataOnce(
    firestore.doc("utility/sources"),
    { idField: "id" }
  );

  // get bank imtegrasion
  const [integrasionPayments, loadingIntegrasionPayments] =
    useCollectionDataOnce(firestore.collection("integrations/moota/banks"), {
      idField: "id",
    });

  // get bank imtegrasion
  const [mootaConfig, loadingMootaConfig] = useDocumentData(
    firestore.doc("integrations/moota"),
    { idField: "id" }
  );

  //get commission
  const [config_komisi, loadingKomisi] = useDocumentDataOnce(
    firestore.doc("utility/komisi"),
    { idField: "id" }
  );

  // get typesense integration
  const [typesenseConfig, loadingTypesenseConfig] = useDocumentDataOnce(
    firestore.doc("integrations/typesense"),
    { idField: "id" }
  );

  //get products campaigns
  const productsCampaignsRef = productsCampaignsCollections.where(
    "status",
    "==",
    "active"
  );
  const [products_campaigns, loadingProductsCampaigns] = useCollectionData(
    productsCampaignsRef,
    {
      idField: "id",
    }
  );

  // get collection product
  const [collectionProduct, loadingCollectionProduct] = useCollectionData(
    collectionProductRef.where("visible", "==", true),
    {
      idField: "id",
    }
  );

  const [countdownList, loadingContdownList] = useDocumentDataOnce(
    firestore.doc("utility/countdown"),
    { idField: "id" }
  );
  const [recomendationsCustomList, loadingCustomRecomendation] =
    useDocumentDataOnce(firestore.doc("utility/sorting"), { idField: "id" });

  useEffect(() => {
    popups?.forEach((_, b) => {
      return setVisiblePopups((data) => ({
        ...data,
        [b]: {
          status: true,
          hidden: b === 0 ? false : true, // pop up pertama tidak di sembunyikan
        },
      }));
    });
  }, [popups]);

  //get preorder utils
  const [preorderUtils, loadingPreorderUtils] = useDocumentDataOnce(
    firestore.doc("utility/preorder"),
    { idField: "id" }
  );

  if (
    loadingInpoinActivity ||
    loadingUserInpoin ||
    loadingProfil ||
    loadingLevel ||
    loadingWebstore ||
    loadingSubdomain ||
    loadingOrders ||
    loadingAlamat ||
    loadingCart ||
    loadingCategories ||
    loadingBelanjaKredit ||
    loadingPencairan ||
    loadingKredit ||
    loadingBankSeller ||
    loadingTopup ||
    loadingSlider ||
    loadingPhone ||
    loadingOrderCreation ||
    loadingPromo ||
    loadingPoint ||
    loadingPenukaran ||
    loadingPromoOngkir ||
    loadingAlamatPusat ||
    loadingKomisi ||
    // loadingGlobal_Komisi ||
    loadingGlobal_resi_mp ||
    loadingMenu_alamat ||
    loadingVerifikasiData ||
    loadingList_pekerjaan ||
    loadingCampaignsInfaq ||
    loadingCampaigns ||
    loadingVoucherData ||
    loadingInpoinHow ||
    loadingInpoinAbout ||
    loadingConfiguration ||
    loadingPopups ||
    loadingJenisBrand ||
    loadingPerformance ||
    loadingSourceCategories ||
    loadingIntegrasionPayments ||
    loadingMootaConfig ||
    loadingTypesenseConfig ||
    loadingCollectionProduct ||
    loadingContdownList ||
    loadingCustomRecomendation ||
    loadingProductsCampaigns ||
    loadingPreorderUtils
  ) {
    return <AppLoading />;
  }


  let global_komisi = config_komisi?.base_value;
  let scope_level_komisi = performance?.level_scope;

  if (
    global_settings?.aktivasi_komisi_berdasarkan_performa &&
    scope_level_komisi.some((item) => item === level?.level)
  ) {
    let isPerfomance = level?.performance ? level?.performance : 0;
    let configPerformanceBase = config_komisi?.performance_base?.[isPerfomance];
    let nilaiKomisi =
      configPerformanceBase?.operator === "-"
        ? global_komisi?.[level?.level] - configPerformanceBase?.value
        : global_komisi?.[level?.level] + configPerformanceBase?.value;

    nilaiKomisi = nilaiKomisi > 0 ? nilaiKomisi : 0;
    global_komisi = {
      ...global_komisi,
      [level?.level]: nilaiKomisi,
    };
  }

  return (
    <DataContext.Provider
      value={{
        inpoinActivity,
        inpoinRef,
        userInpoin,
        profil,
        level,
        webstore,
        profilRef,
        levelRef,
        flatCategories: categories,
        categories: arrayToTree(categories, {
          idField: "id",
          parentId: "parent",
          childrenField: "sub",
          dataField: null,
        }),
        loadingCategories,
        cart,
        cartRef,
        loadingCart,
        alamat,
        alamatRef,
        loadingAlamat,
        webstoreRef,
        subdomain: subdomain?.[0],
        orders,
        loadingOrders,
        belanjaKredit,
        pencairan,
        kredit,
        kreditRef,
        bankSeller,
        topupRef,
        slider,
        alamat_pusat,
        topup,
        phone: phone?.[0],
        global_settings,
        point,
        promo,
        penukaran,
        promoOngkir,
        global_komisi,
        global_resi_mp,
        menu_alamat,
        list_pekerjaan,
        verifikasiData,
        campaignsInfaq,
        campaigns,
        voucherData,
        inpointHow,
        inpointAbout,
        configuration,
        jenisBrand,
        sourceCategories,
        integrasionPayments,
        mootaConfig,
        popups,
        visiblePopups,
        setVisiblePopups,
        typesenseConfig,
        collectionProduct,
        countdownList,
        recomendationsCustomList,
        products_campaigns,
        preorderUtils
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
}
